import { Box,styled } from '@mui/material'
import React from 'react'
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import InstagramIcon from '@mui/icons-material/Instagram';

const Wrapper=styled(Box)`
    width:100%;
    display:flex;
    justify-content:center;
    align-items:center;
    height: 233px;
    background: #010B30;
    margin-top: 20px;
`

const footer = () => {

    const LinkedIn=()=>{
    window.open('https://www.linkedin.com/in/ayush-dahala-b85aa519b/','_blank');
    }

    const gitHub=()=>{
        window.open('https://github.com/Ayush-Dahala','_blank');
    }

    const instagramOpen=()=>{
        window.open('https://www.instagram.com/ayush_dahala/','_blank');
    }

  return (
    <Wrapper>
        <LinkedInIcon style={{fontSize:'70px',marginRight:'15px',color:'grey',cursor:'pointer'}} onClick={LinkedIn}/>
        <GitHubIcon style={{fontSize:'70px',marginRight:'15px',color:'grey',cursor:'pointer'}} onClick={gitHub}/>
        <InstagramIcon style={{fontSize:'70px',color:'grey',cursor:'pointer'}} onClick={instagramOpen}/>
    </Wrapper>
  )
}

export default footer
